import React from 'react';
import useInlineAnswers from '../useInlineAnswers';
export default function InlineAnswers({ store, scope, onDisabled }) {
  const answers = useInlineAnswers(store, scope, onDisabled);
  const inputId = `question-${scope.materialId}-${scope.sectionId || 'material'}`;
  return <aside className="portfolio-answers" aria-label={`Questions about ${scope.label}`}>
    <h3>Questions about {scope.label}</h3>
    <div aria-label="Stored answers">{answers.messages.map((message, index) => <div key={index}>
      <p className="font-semibold">{message.question}</p><p>{message.text}</p>
    </div>)}</div>
    {answers.notice && <p role="status">{answers.notice}</p>}
    {answers.review && !answers.needsReload && <button onClick={answers.reviewContent}>I reviewed the updated content</button>}
    {answers.suggestions.map((suggestion) => <button key={suggestion}
      onClick={() => answers.setDraft(suggestion)}>{suggestion}</button>)}
    <form onSubmit={(event) => { event.preventDefault(); answers.submit(); }} aria-busy={answers.loading}>
      <label htmlFor={inputId}>Ask about this {scope.sectionId ? 'section' : 'material'}</label>
      <textarea id={inputId} value={answers.draft} maxLength={2000}
        aria-describedby={answers.error ? `${inputId}-error` : undefined}
        onChange={(event) => answers.setDraft(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' && !event.shiftKey && !event.nativeEvent.isComposing) {
            event.preventDefault(); answers.submit();
          }
        }} />
      <button type="submit" disabled={answers.loading || answers.review || answers.invalid || !answers.draft.trim()}>
        {answers.loading ? 'Answering…' : 'Ask'}</button>
      {answers.loading && <p role="status">Looking for a stored answer…</p>}
      {answers.error && <p id={`${inputId}-error`} role="status">{answers.error}</p>}
    </form>
  </aside>;
}
